import React from 'react';
import ReactDOM from 'react-dom';
import './styles/variable.css';
import './index.css';
import App from './app/App';
import store from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { StyledEngineProvider } from '@mui/material/styles';
import * as ReactDOMClient from 'react-dom/client';

// AL-71: capture the engagement-email deep link (?askq=&pid=) BEFORE anything
// else runs — the login redirect would otherwise eat the query string. The
// wizard consumes the stash once the user is authenticated and mounted.
try {
  const _p = new URLSearchParams(window.location.search);
  if (_p.get("askq")) {
    sessionStorage.setItem("lqx_askq", JSON.stringify({
      q: _p.get("askq"), pid: _p.get("pid") || "", ts: Date.now(),
    }));
    _p.delete("askq"); _p.delete("pid");
    const rest = _p.toString();
    window.history.replaceState({}, "",
      window.location.pathname + (rest ? `?${rest}` : "") + window.location.hash);
  }
} catch (_) { /* storage unavailable — the link still lands on the app */ }

// const rootElement = document.getElementById("root");

// const root = ReactDOMClient.createRoot(rootElement);
// root.render(  <React.StrictMode>
//   <Provider store={store}>
//     <StyledEngineProvider injectFirst>
//       <App />
//     </StyledEngineProvider>
//   </Provider>
// </React.StrictMode>);
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
